// Every routing-server error renders as {error, status_code} — surface `error` as the message.
// `body` keeps the parsed payload for responses that carry more than a message (actuator answers
// a failing health check with 503 and the full component breakdown).
export class ApiError extends Error {
  statusCode: number;

  body: unknown;

  constructor(message: string, statusCode: number, body?: unknown) {
    super(message);
    this.statusCode = statusCode;
    this.body = body;
  }
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(path, options);
  const text = await response.text();
  let body: unknown = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    body = text;
  }
  if (!response.ok) {
    const envelope = body as { error?: string } | null;
    throw new ApiError(
      envelope?.error ?? `${response.status} ${response.statusText}`,
      response.status,
      body
    );
  }
  return body as T;
}

export const apiService = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) =>
    request<T>(path, {
      method: 'POST',
      headers: body === undefined ? undefined : { 'Content-Type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body)
    }),
  put: <T>(path: string, body: unknown) =>
    request<T>(path, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }),
  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' })
};
